import { clsx } from 'clsx';
/**
 * Utility function to merge class names
 */
export function cn(...inputs) {
    return clsx(inputs);
}
